export const isWechat = () => {
  if (process.server) return false;
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('micromessenger') !== -1;
};